import { action } from "../../../utils/actions";

export const OPEN_PROJECT_DASHBOARD = action("OPEN_PROJECT_DASHBOARD");
export const GET_PROJECT_DASHBOARD_DATA = action("GET_PROJECT_DASHBOARD_DATA");
export const GET_PROJECT_DASHBOARD_REPORT_HEALTH_RISKS = action(
  "GET_PROJECT_DASHBOARD_REPORT_HEALTHRISKS",
);
export const GENERATE_PDF = action("GENERATE_PDF");
